import 'Assets/styles/default/pages/FocalPoint/ListManagePointsStyles.less';
import { Form, Table, Typography, VertBreadcrumb, VertButton, VertContainer, VertDatePicker, VertIcon, VertInput, VertLoading, VertSelect } from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import PersonIcon from 'components/FocalPoint/Icons/Person';
import { useNavigate } from 'react-router';
import { getListManagePointsThunk } from 'redux/Reducers/FocalPoint/getListManagePointsSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { pointsMask } from 'Utils/commons/points';
import { EStatusDistributionAvailableAndHistory } from './Enums/StatusDistributionAvailableAndHistoryEnum';
import { getParticipantIsFocalPointThunk, resetDataGetParticipantIsFocalPoint } from 'redux/Reducers/FocalPoint/getParticipantIsFocalPointSlicer';

const ListManagePointsPage = () => {

    const Catalog = useSelector(({ Catalog: data }) => data);
    const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;
    const [totalDistribution, setTotalDistribution] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [desc, setDesc] = useState(false);
    const [optionSelected, setOptionSelected] = useState(1);
    const [timer, setTimer] = useState(null);
    const [listBalances, setListBalances] = useState([]);
    const [filter, setFilter] = useState('');
    const [deadline, setDeadline] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userProfile = useSelector(({ Participants: data }) => data);

    const columns = [
        {
            title: 'Canal de Distribuição',
            dataIndex: 'distributionChannel',
            align: 'center'
        },
        {
            title: 'Nome do Programa',
            dataIndex: 'programName',
            align: 'center'
        },
        {
            title: 'Valor Disponível',
            dataIndex: 'balance',
            align: 'center',
            render: (balance) => (
                <Row justify={'center'} align={'middle'}>
                    <Col>
                        {pointsMask(balance, decimalPlaces, pointsName).value}
                    </Col>
                </Row>
            )
        },
        {
            title: 'Data Limite',
            dataIndex: 'deadline',
            align: 'center',
            render: (deadline) => (
                <Row justify={'center'} align={'middle'}>
                    {deadline == null ?
                        <Col>
                            <span> - </span>
                        </Col>
                        :
                        <Col>
                            {deadline}
                        </Col>
                    }
                </Row>
            )
        },
        {
            title: 'Status',
            dataIndex: 'statusDescription',
            align: 'center',
            width: '260px',
            render: (statusDescription, object) => (
                <Row>
                    {
                        object.status == EStatusDistributionAvailableAndHistory.DistributionApproved &&
                        <Col span={24} className='container-chip-status'>
                            <div className={'status-approved-background'}>
                                <Typography.Text className={'text-status-approved'}> {statusDescription} </Typography.Text>
                            </div>
                        </Col>
                    }
                    {
                        object.status == EStatusDistributionAvailableAndHistory.DistributionExpired &&
                        <Col span={24} className='container-chip-status'>
                            <div className={'status-error-background'}>
                                <Typography.Text className={'text-status-distribution-error'}> {statusDescription} </Typography.Text>
                            </div>
                        </Col>
                    }
                    {
                        (
                            object.status == EStatusDistributionAvailableAndHistory.ApprovingPending ||
                            object.status == EStatusDistributionAvailableAndHistory.DistributionPending
                        ) &&
                        <Col span={24} className='container-chip-status'>
                            <div className={'status-pending-background'}>
                                <Typography.Text className={'text-status-pending'}> {statusDescription} </Typography.Text>
                            </div>
                        </Col>
                    }
                </Row>
            )
        },
        {
            title: 'Ação',
            dataIndex: 'type',
            align: 'center',
            width: '180px',
            render: (_, { type, id, status }) => (
                <Row
                    onClick={() => {
                        {
                            if (status == EStatusDistributionAvailableAndHistory.DistributionExpired) {
                                return;
                            }
                            type == 1 ?
                                navigate(`/focal-point-manage-points/${id}`) :
                                navigate(`/list-details-distribution-points/${id}`)
                        }
                    }}
                    justify={'center'}
                    align={'middle'}
                >
                    <Col>
                        <Typography.Text style={{ width: '100%' }} className={status == EStatusDistributionAvailableAndHistory.DistributionExpired ? 'action-button-disabled' : 'action-button'}>
                            {
                                type == 1 ?
                                    <>
                                        Distribuir
                                    </>
                                    :
                                    <>
                                        Mostrar detalhes
                                    </>
                            }
                        </Typography.Text>
                    </Col>
                </Row>
            )
        }
    ];

    const {
        dataGetListManagePoints,
        loadingGetListManagePoints,
        errorGetListManagePoints
    } = useSelector(
        (state) => state.GetListManagePoints
    );

    const {
        dataGetParticipantIsFocalPoint,
        loadingGetParticipantIsFocalPoint,
        finishedParticipantIsFocalPoint
    } = useSelector(
        (state) => state.GetParticipantIsFocalPoint
    );

    const handleFilter = (value) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            dispatch(getListManagePointsThunk({
                filter: value,
                pageSize: 10,
                currentPage: 0,
                desc,
                deadline
            }));
            setFilter(value);
            setCurrentPage(0);
        }, 300);
        setTimer(newTimer);
    }

    const searchBySolicitationDate = (deadline) => {
        setCurrentPage(0);
        setDeadline(deadline);
        dispatch(getListManagePointsThunk({
            filter: filter,
            pageSize: 10,
            currentPage: 0,
            desc,
            deadline
        }));
    }

    const handleOrder = (val) => {
        setOptionSelected(val);
        setCurrentPage(0);
        setDesc(val == 2);
        dispatch(getListManagePointsThunk({
            filter: filter,
            pageSize: 10,
            currentPage: 0,
            desc: val == 2,
            deadline
        }));
    }

    const handlePagination = (value) => {
        var currentPage = --value.current;
        setCurrentPage(currentPage);
        dispatch(getListManagePointsThunk({
            filter: filter,
            pageSize: 10,
            currentPage: currentPage,
            desc,
            deadline
        }));
    }

    useEffect(() => {
        if (dataGetListManagePoints && dataGetListManagePoints.length) {
            setListBalances(dataGetListManagePoints);
            setTotalDistribution(dataGetListManagePoints[0].total);
        }
    }, [dataGetListManagePoints]);

    useEffect(() => {
        if (finishedParticipantIsFocalPoint) {
            if (!dataGetParticipantIsFocalPoint) {
                dispatch(resetDataGetParticipantIsFocalPoint());
                navigate('/home');
                return;
            }
            dispatch(getListManagePointsThunk({
                filter: filter,
                pageSize: 10,
                currentPage: 0,
                desc,
                deadline
            }));
        }
    }, [finishedParticipantIsFocalPoint]);

    useEffect(() => {
        if (!dataGetParticipantIsFocalPoint) {
            dispatch(getParticipantIsFocalPointThunk());
            return;
        }
    }, []);

    return (
        <>
            <VertContainer spacingX="regular" spacingY="regular">

                <VertBreadcrumb
                    separator={<VertIcon component={RightOutlined} />}
                    items={[
                        {
                            title: 'Início',
                            path: '/',
                        },
                        {
                            title: `Gerenciar distribuição de ${pointsName}`,
                            path: '/list-manage-points',
                        }
                    ]}
                />

                <Row className='container-title-main'>
                    <Col span={24}>
                        <Typography.Text className='text-title'>
                            Gerenciar distribuição de {pointsName}
                        </Typography.Text>
                    </Col>
                </Row>

                <Row className='container-title-main' justify={'space-between'}>
                    <Col xs={12} sm={12} md={16} lg={18} xl={19}>
                        <div className='container-participant-info'>
                            <Row gutter={[24, 24]}>
                                <Col>
                                    <PersonIcon />
                                </Col>

                                <Col>
                                    <Typography.Text className="user-information-title">
                                        {'Focal Point'}
                                    </Typography.Text>
                                </Col>
                            </Row>

                            <div className='margin-top-extra-small'>
                                <Typography.Text className="user-information-title">
                                    {userProfile.name.value}
                                </Typography.Text>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={8} lg={6} xl={5}>
                        <VertButton
                            type="default"
                            size="default"
                            className='button-historic-redirect button-100-width'
                            onClick={() => navigate("/list-history-distribution-points")}
                        >
                            Histórico de {pointsName}
                        </VertButton>

                    </Col>
                </Row>

                <Row gutter={24} align={'middle'} className={'margin-top-divider'} style={{ marginTop: '16px' }}>
                    <Col xs={24} sm={24} md={11} lg={12}>
                        <Form.Item>
                            <VertInput label='Buscar'
                                onChange={({ target }) => handleFilter(target.value)}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={7} lg={6} >
                        <Form.Item>
                            <VertDatePicker
                                picker="date"
                                format="DD/MM/YYYY"
                                placement="bottomLeft"
                                popupClassName='datepicker-delivery-popup'
                                className='datepicker-delivery'
                                placeholder="Data limite"
                                value={deadline}
                                onChange={res => searchBySolicitationDate(res)}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6} lg={6}>
                        <Form.Item>
                            <VertSelect
                                value={optionSelected}
                                onChange={val => {
                                    handleOrder(val);
                                }}
                                placeholder='Ordenar status'
                                items={[
                                    {
                                        value: 1,
                                        label: "Pendente de distribuição"
                                    },
                                    {
                                        value: 2,
                                        label: "Distribuição aprovada"
                                    }
                                ]} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        {
                            errorGetListManagePoints ?
                                <Typography.Text className='text-title text-not-found'>
                                    Houve um erro ao buscar as campanhas
                                </Typography.Text>
                                :
                                <>
                                    {
                                        (loadingGetListManagePoints || loadingGetParticipantIsFocalPoint) ?
                                            <>
                                                <VertLoading className='loading-space' />
                                            </>
                                            :
                                            <>
                                                {
                                                    dataGetListManagePoints.length > 0 ?
                                                        <>
                                                            <Table
                                                                onChange={handlePagination}
                                                                className='table-focal-point'
                                                                pagination={{
                                                                    showSizeChanger: false,
                                                                    pageSize: 10,
                                                                    total: totalDistribution,
                                                                    position: ['bottomCenter'],
                                                                    current: currentPage + 1
                                                                }}
                                                                bordered
                                                                columns={columns}
                                                                dataSource={listBalances}
                                                            />
                                                        </>
                                                        :
                                                        <Typography.Text className='text-title text-not-found'>
                                                            Não foi encontrada nenhuma campanha
                                                        </Typography.Text>
                                                }
                                            </>
                                    }

                                </>
                        }

                    </Col>
                </Row>

            </VertContainer >
        </>
    )
}

export default ListManagePointsPage;